import { render, staticRenderFns } from "./dialogDetail.vue?vue&type=template&id=dc77e0da&scoped=true&"
import script from "./dialogDetail.vue?vue&type=script&lang=js&"
export * from "./dialogDetail.vue?vue&type=script&lang=js&"
import style0 from "./dialogDetail.vue?vue&type=style&index=0&id=dc77e0da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc77e0da",
  null
  
)

export default component.exports